import { configureStore } from "@reduxjs/toolkit"
import { reportApi } from "../services/api"
import groupFilterReducer from "./groupFilterSlice"
import sessionReducer from "./sessionSlice"

export const store = configureStore({
  reducer: {
    session: sessionReducer,
    groupFilter: groupFilterReducer,
    [reportApi.reducerPath]: reportApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(reportApi.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
